import { render, staticRenderFns } from "./UnfinalizeTruckModal.vue?vue&type=template&id=65c5f02e"
import script from "./UnfinalizeTruckModal.vue?vue&type=script&lang=ts"
export * from "./UnfinalizeTruckModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports